module.exports = __webpack_public_path__ + "img/time.03c71cfa.png";